module.exports = {"title":"A final interview","date":"2017-06-04T19:00:00.000+01:00","path":"/2017-06-04/interview/","author":"HARRISON","body":"<p>=YOUTUBESTART=jsuaPucT1DI=YOUTUBEEND=</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2017-06-04-harrison/index.md
// module id = 1071
// module chunks = 0